import React, { useEffect, useState } from 'react'
import Header from '../header/Header'
import PaymentComponent from '../testpages/TestShopRapyd2'
import { useParams } from 'react-router-dom'
import './checkoutpage.css'
import OneCartItem from './OneCartItem'
import CheckoutTotal from './CheckoutTotal'
import CountrySelect from './CountrySelect'
import Billingdetails from './Billingdetails'
import { UserAuth } from '../context/AuthContext'; // Adjust this import path accordingly
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js'
import { useNavigate, useLocation } from 'react-router-dom'
import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase';
import BundleUpsell from './BundleUpsell';
import salepicAurora from '../assets/AuroraSalePicSmall.png';
import salepicRefract from '../assets/RefractPromoImg3.jpg';
import salepicDuck from '../assets/DuckProduct2.jpg';

const CheckoutPage = () => {
    const [page, setPage] = useState(0);
    const [billingDetails, setBillingDetails] = useState({});
    const [data, setData] = useState(null)
    const location = useLocation();

    // Support array inputs for Bundle Checkout, otherwise fallback to single product payload or default Aurora
    const initialCart = location.state?.products || 
                        (location.state?.product ? [location.state.product] : 
                        [{ id: 1, name: "Aurora", price: 29.99, originalPrice: 49.99, img: salepicAurora }]);

    const [cart, setCart] = useState(initialCart);
    const [orderlink, setOrderLink] = useState("https://ts-payment-l6tiifacuq-uc.a.run.app/create-order")

    // Detect active bundles
    const hasAurora = cart.some(item => item.id === 1);
    const hasRefract = cart.some(item => item.id === 2);
    const hasDuck = cart.some(item => item.id === 3);

    const isEverythingBundle = hasAurora && hasRefract && hasDuck;
    const isRefractAuroraBundle = hasAurora && hasRefract && !hasDuck;
    const isRefractDuckBundle = hasRefract && hasDuck && !hasAurora;

    // Smart pricing orchestrator
    const calculateTotals = (cartItems) => {
        const _hasAurora = cartItems.some(i => i.id === 1);
        const _hasRefract = cartItems.some(i => i.id === 2);
        const _hasDuck = cartItems.some(i => i.id === 3);

        if (_hasAurora && _hasRefract && _hasDuck) return { current: 54.99, original: 129.97 };
        if (_hasAurora && _hasRefract && !_hasDuck) return { current: 44.99, original: 99.98 };
        if (_hasRefract && _hasDuck && !_hasAurora) return { current: 39.99, original: 79.98 };

        // Fallback or unbundled permutations (e.g. Aurora + Duck = 49.98)
        let currentTotal = 0;
        let originalTotal = 0;
        cartItems.forEach(item => {
            currentTotal += item.price;
            originalTotal += (item.originalPrice || 49.99); // Safe fallback
        });
        return { current: currentTotal, original: originalTotal };
    };

    const initialTotals = calculateTotals(cart);
    const [checkoutTotal, setCheckoutTotal] = useState(`${initialTotals.current.toFixed(2)}$`);
    const [checkoutOriginalTotal, setCheckoutOriginalTotal] = useState(`${initialTotals.original.toFixed(2)}$`);
    const { user } = UserAuth();

    const params = useParams();

    const navigate = useNavigate();

    const nextPage = () => {
        if (page == 0 || page == 1) {
            if (billingDetails.formFilled && locationData.countryCode != '' || page == 0) {
                setPage(page + 1);
            }
        }
    }

    const prevPage = () => {
        if (page == 1 || page == 2) {
            setPage(page - 1);
        }
    }

    // Recalculate string total dynamically whenever cart changes
    useEffect(() => {
        const _hasAurora = cart.some(item => item.id === 1);
        const _hasRefract = cart.some(item => item.id === 2);
        const _hasDuck = cart.some(item => item.id === 3);

        const newTotals = calculateTotals(cart);

        // Ensure Iceland pricing logic applies safely. Note: Iceland doesn't seem to have new bundle overrides explicitly written out yet, defaulting logic to main.
        if (params.country === "iceland") {
            let activeICETotal = newTotals.current;
            if (_hasAurora && _hasRefract && !_hasDuck) activeICETotal = 44.98; // preserve old behavior
            setCheckoutTotal(`${activeICETotal}$`);
            setCheckoutOriginalTotal(`${newTotals.original}$`);
        } else {
            setCheckoutTotal(`${newTotals.current.toFixed(2)}$`);
            setCheckoutOriginalTotal(`${newTotals.original.toFixed(2)}$`);
        }
    }, [cart, params.country]);

    useEffect(() => {
        if (params.country === "iceland") {
            setOrderLink("https://ts-payment-l6tiifacuq-uc.a.run.app/create-order-iceland")
        }
    }, [])

    const handleAddBundle = (id, name, price, originalPrice, img) => {
        setCart([...cart, { id, name, price, originalPrice, img }]);
    };

    useEffect(() => {

    }, [billingDetails])

    const handlePaypalClick = () => {
        logEvent(analytics, "Rapyd_failed_paypal_option_selected")
        setPage(0);
    }

    return (
        <div>
            <Header />
            <div className="salepage__img">
                {/* <img src={bgImg} alt="img" className='salepage__imgsize' />*/}
            </div>


            <div className="checkout__contentcontainer">
                <div className="checkout__screen">

                    {/*   <div className="checkout__countryselector">
                        <CountrySelect />
    </div>*/}
                    {page === 0 && (
                        <div className="checkout__paymentcomponent">


                            <div className="checkout__optiontitle">
                                Checkout via PayPal
                            </div>

                            <PayPalScriptProvider
                                //options={{ "client-id": "AbxmWGRh0N2_8-gGYvj0K2PR3kKvNpf-nTR74zyGGiRQx7Cj72QBwnIpoaK74RLlvB_eoDTAeKCBH75f" }}>
                                options={{ "client-id": "AZj3muinRRGJvp5uJE1DFGUDA5nHL4O2C7-0Aj-6eL_0ZypyE3bhnp2qIw9sIF62waIjiaU1Tk0VRaky" }}>
                                <PayPalButtons
                                    forceReRender={[cart]}
                                    className='checkout__paypal'
                                    createOrder={() => {
                                        logEvent(analytics, "PayPal_selected")
                                        return fetch(orderlink, {
                                            method: "POST",
                                            headers: {
                                                "Content-Type": 'application/json'
                                            },
                                            body: JSON.stringify({
                                                items: cart.map(item => ({
                                                    id: item.id,
                                                    quantity: 1
                                                })),
                                                userid: [user.uid],
                                                // Optional: Passing bundle details for the backend if needed 
                                                bundle: cart.length > 1
                                            }),
                                        })
                                            .then(res => {
                                                if (res.ok) return res.json()
                                                return res.json().then(json => Promise.reject(json))
                                            })
                                            .then(({ id }) => {

                                                return id
                                            })
                                            .catch(e => {
                                                console.error(e.error)
                                            })
                                    }}
                                    onApprove={async (data, actions) => {
                                        try {
                                            const response = await fetch('https://ts-payment-l6tiifacuq-uc.a.run.app/capture-order', {
                                                method: "POST",
                                                headers: {
                                                    "Content-Type": 'application/json'
                                                },
                                                body: JSON.stringify({
                                                    orderId: data.orderID
                                                }),
                                            });

                                            if (!response.ok) {
                                                const errorData = await response.json();
                                                throw new Error(errorData.error);
                                            }

                                            // Explicit Facebook Purchase Pixel Tracking (With Deduplication Stamp)
                                            trackPixelEvent('Purchase', { 
                                                value: totals.current, 
                                                currency: 'USD' 
                                            }, data.orderID);

                                            const purchasedNames = cart.map(item => item.name).join('_');
                                            navigate(`/thanksforpurchase/${purchasedNames}`);
                                        } catch (error) {
                                            console.error('Error capturing order:', error);
                                            // Handle the error appropriately in the UI
                                        }
                                    }}
                                />
                            </PayPalScriptProvider>
                        </div>
                    )}


                    {page === 1 && (
                        <div className="checkout__paymentcomponent">

                            <div>
                                <Billingdetails setBillingDetails={setBillingDetails} />
                            </div>

                            <div className="checkout__nextpagebutton"
                                onClick={() => { nextPage() }}
                            >
                                Next Page
                            </div>

                        </div>
                    )}


                    {page === 2 && (
                        <div className='checkout__paymentcomponent'>
                            <PaymentComponent checkoutid={params.checkoutid} billingDetails={billingDetails} data={data}
                                errorMessage={errorMessage} setErrorMessage={setErrorMessage} />
                            <div>
                                <div>
                                    {errorMessage}
                                </div>
                                <div
                                    className='checkout__trypaypal'
                                    style={{ textDecoration: 'underline', color: 'blue', cursor: 'pointer' }}
                                    onClick={handlePaypalClick}
                                >
                                    Not Working? Try PayPal
                                </div>
                            </div>
                        </div>


                    )}


                    <div className="checkout__middleline"></div>

                    <div className="checkout__info">

                        {cart.map((item, index) => {
                            let displayPrice = item.price;
                            
                            // Visual masking for the display lines to make them sum to the bundle overide
                            const _hasAur = cart.some(i => i.id === 1);
                            const _hasRef = cart.some(i => i.id === 2);
                            const _hasDck = cart.some(i => i.id === 3);
                            
                            if (_hasAur && _hasRef && _hasDck) {
                                if (item.id === 1) displayPrice = 24.99;
                                if (item.id === 2) displayPrice = 15.00;
                                if (item.id === 3) displayPrice = 15.00;
                            } else if (_hasAur && _hasRef && !_hasDck) {
                                if (item.id === 1) displayPrice = 29.99; // Base
                                if (item.id === 2) displayPrice = 15.00; // Deep discount remainder
                            } else if (_hasRef && _hasDck && !_hasAur) {
                                if (item.id === 2) displayPrice = 24.99;
                                if (item.id === 3) displayPrice = 15.00;
                            }

                            // Auto-select correct image based on ID 
                            let _img = salepicAurora;
                            if (item.id === 2) _img = salepicRefract;
                            if (item.id === 3) _img = salepicDuck;

                            return (
                                <OneCartItem
                                    key={`${item.id}-${index}`}
                                    name={item.name}
                                    img={item.img || _img}
                                    originalPrice={`${item.originalPrice || 49.99}$`}
                                    price={`${displayPrice}$`}
                                />
                            );
                        })}

                        <BundleUpsell cart={cart} onAddBundle={handleAddBundle} />

                        <div className="checkout__whitespace">

                        </div>

                        <CheckoutTotal price={checkoutTotal} originalPrice={checkoutOriginalTotal} />

                    </div>
                </div>
            </div>
        </div>
    )
}

export default CheckoutPage